import jsPDF from "jspdf";
import DateFormat from "../../components/dateFormater/dateFormat1";
import { dataTel3SignImage, generalImage } from "../../config/apiSPA";
import { blobToBase64 } from "file64";
async function Tel3PdfGenerator(data) {
  const generator = new Generate();
  await generator.set(data);
}
export default Tel3PdfGenerator;

class Generate {
  constructor(options) {
    this.initialX = 8;
    this.tab = 10;
    this.data = null;
    this.doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });
  }

  async set(data) {
    this.data = data;
    await this.setTemplate();
    await this.setContent();
    this.evalName();
    this.signDate();
    const fileName = `TEL_3_${this.data.partData.nama}_${this.data.main.training.trainingCode.title}_${DateFormat(this.data.main.training.startDate).pdf}`;
    this.doc.save(fileName);
  }
  async setContent() {
    this.doc.setTextColor(60, 60, 60);
    this.trainingInfoContent();
    this.tableContent();
    this.checkBoxContent(this.data.finalScore);
    this.textResult();
    await this.signImage();
  }
  async setTemplate() {
    this.doc.setTextColor(0, 0, 0);
    await this.logoPrint();
    this.title();
    this.trainingInfo();
    this.sectionNumbering("1.", "Evaluasi Hasil Pelatihan", "(Training Evaluation Result)", 96);
    this.paragraphLvl2("Berikan tanda 'v' pada kolom yang dianggap sesuai !", "Please put v sign to the suitable column !", 102.3);
    this.table();
    this.tableText();
    this.sectionNumbering("2.", "Kesimpulan", "(Conclusion)", 168);
    this.sectionNumberingLvl2("2.1.", "Pelatihan ini (The training is) :", 171.3);
    this.checkboxList();
    this.sectionNumberingLvl2("2.2.", "Apakah  ada peningkatan kompetensi setelah mengikuti pelatihan ini? (Is there any competency improvement after following this training ? Yes / no*) : ", 200.6);
    this.sectionNumberingLvl2("", "Jelaskan! (Please Describe!)", 203.7);
    this.drawDashedLines(16.9, 204.5, 3);
    this.sectionNumberingLvl2("2.3.", "Saran dan Tindak Lanjut (Suggestion and Follow up )  :", 216.9);
    this.drawDashedLines(16.9, 217.5, 4);
    this.weighing();
    this.sign();
    this.footer();
    this.header();
  }

  //==========================
  // Content Section
  //==========================
  trainingInfoContent() {
    const startX = 62;
    const startY = 29;
    const render1 = (val, x, y) => {
      let xPos = x;
      const tab = this.tab;
      this.doc.setFont("helvetica", "normal");
      this.doc.setFontSize(8);
      this.doc.text(val.text, xPos, y);
      return y + 9;
    };
    const render2 = (text, x, y) => {
      const xPos = x + 3;
      this.doc.text(text, xPos, y);
      return y + 5;
    };
    const content = [
      { text: this.data.partData.nama },
      { text: this.data.main.training.trainingCode.title },
      { text: this.data.main.training.instructorData.namaInstructor },
      { text: `${this.data.main.training.locationData.location}, ${this.data.main.training.startDate} - ${this.data.main.training.endDate}` },
      { text: this.data.main.training.institutionData.institutionName },
    ];
    let y = startY;
    content.forEach((val) => {
      y = render1(val, startX, y);
    });

    const list = this.data.main.trainingGoals;
    for (let i = 0; i < 4; i++) {
      const text = list[i] ? list[i].text : "-";
      y = render2(text, startX, y);
    }
  }
  tableContent() {
    const startX = 129;
    const startY = 123.2;
    const render = (val, xx, y) => {
      let x = xx;
      this.doc.text(val.weight.toString(), x, y);
      x += 12;
      if (val.score === 1) this.doc.text("V", x, y);
      if (val.score === 2) this.doc.text("V", x + 12, y);
      if (val.score === 3) this.doc.text("V", x + 24, y);
      if (val.score === 4) this.doc.text("V", x + 36, y);
      x += 48;
      this.doc.text(val.totalScore.toString(), x, y);
      return y + 11.6;
    };
    const resultVal = this.data.resultNumb;
    if (resultVal.length < 1) return;
    let y = startY;
    for (let i = 0; i < 3; i++) {
      if (resultVal[i]) {
        const r = {
          weight: resultVal[i].weighning,
          score: resultVal[i].score,
          totalScore: resultVal[i].totalScore,
        };
        y = render(r, startX, y);
      } else {
        const r = {
          weight: "-",
          score: "-",
          totalScore: "-",
        };
        y = render(r, startX, y);
      }
    }
    this.doc.text(this.data.finalScore.toString(), startX + 60, 158.7);
  }
  checkBoxContent(val) {
    const startX = 18.5;
    const startY = 174.6;
    const step = 6.5;
    let index = 0;
    if (val >= 0 && val < 2) index = 3;
    else if (val >= 2 && val < 3) index = 2;
    else if (val >= 3 && val < 4) index = 1;
    else if (val === 4) index = 0;
    else return;

    this.doc.text("V", startX, startY + step * index);
  }
  textResult() {
    const renderText1 = (text, startX, startY) => {
      const maxWidth = 182;

      // Set font
      this.doc.setFont("helvetica", "normal");
      this.doc.setFontSize(7);

      // Split text agar otomatis wrap sesuai lebar
      const lines = this.doc.splitTextToSize(text, maxWidth);

      // Render text (multi-line)
      this.doc.text(lines, startX, startY);
    };
    const res = this.data.resultText;
    if (res.length < 1) return;
    if (res) {
      renderText1(res[0]?.ansText ?? "-", 17, 206);
      renderText1(res[1]?.ansText ?? "-", 17, 219);
    }
  }
  evalName() {
    const text = this.data.evaluator.nama;
    const centerX = 160;
    const centerY = 251;
    this.doc.setFont("helvetica", "normal");
    this.doc.setFontSize(7);
    const textWidth = this.doc.getTextWidth(text);
    const x = centerX - textWidth / 2;
    const y = centerY;
    this.doc.text(text, x, y);
  }
  signDate() {
    const date = DateFormat(this.data.updated_at);
    const text = `Tanggal (Date): ${date}`;
    // const textWidth=this.doc.getTextWidth(text)
    this.doc.text(text, 160, 255, { align: "center" });
  }
  async signImage() {
    const res = await dataTel3SignImage(this.data.idPart);
    const base64 = await blobToBase64(res);
    if (base64) {
      const imgData = base64;
      const centerX = 165;
      const centerY = 245;
      const targetHeight = 25;

      const img = new Image();
      img.src = imgData;

      await new Promise((resolve) => {
        img.onload = resolve;
      });

      const aspectRatio = img.width / img.height;
      const targetWidth = targetHeight * aspectRatio;

      const x = centerX - targetWidth / 2;
      const y = centerY - targetHeight / 2;

      this.doc.addImage(imgData, "PNG", x, y, targetWidth, targetHeight);
    }
  }
  //==========================
  // Template Section
  //==========================

  title() {
    let yPos = 17;
    const xPos = 105;
    const text = "Training Evaluation Level 3";
    this.doc.setFont("helvetica", "bold");
    this.doc.setFontSize(12);
    this.doc.text(text, xPos, yPos, { align: "center" });
    const textWidth = this.doc.getTextWidth(text);
    const textStart = xPos - textWidth / 2;
    const textEnd = xPos + textWidth / 2;
    yPos += 1;
    this.doc.line(textStart, yPos, textEnd, yPos);
    this.doc.setFont("helvetica", "italic");
    this.doc.setFontSize(9);
    yPos += 3;
    this.doc.text("(Training Evaluasi Level 3)", xPos, yPos, { align: "center" });
    return yPos;
  }

  trainingInfo() {
    const render1 = (text, colon, text2, y) => {
      let xPos = this.initialX;
      const tab = this.tab;
      this.doc.setFont("helvetica", "normal");
      this.doc.setFontSize(8);
      this.doc.text(text, xPos, y);
      xPos += tab * 5;
      this.doc.text(colon, xPos, y);
      xPos += 3;
      this.doc.line(xPos, y, xPos + 91, y);
      this.doc.setFont("helvetica", "italic");
      this.doc.text(text2, this.initialX, y + 3.2);
      return y + 9;
    };
    const render2 = (text, colon, text2, y) => {
      let xPos = this.initialX;
      const tab = this.tab;
      this.doc.setFont("helvetica", "normal");
      this.doc.setFontSize(8);
      this.doc.text(text, xPos, y);
      xPos += tab * 5;
      this.doc.text(colon, xPos, y);
      this.doc.setFont("helvetica", "italic");
      this.doc.text(text2, this.initialX, y + 3.2);
      this.doc.setFont("helvetica", "normal");
      xPos += 3;
      let yList = y;
      const spaceY = 5;
      this.doc.text("1.", xPos, yList);
      this.doc.line(xPos + 3, yList, xPos + 91, yList);
      yList += spaceY;
      this.doc.text("2.", xPos, yList);
      this.doc.line(xPos + 3, yList, xPos + 91, yList);
      yList += spaceY;
      this.doc.text("3.", xPos, yList);
      this.doc.line(xPos + 3, yList, xPos + 91, yList);
      yList += spaceY;
      this.doc.text("4.", xPos, yList);
      this.doc.line(xPos + 3, yList, xPos + 91, yList);
      return yList + 9;
    };
    const data = [
      {
        text1: "Nama Pekerja",
        colon: ":",
        text2: "Name Of Employee",
      },
      {
        text1: "Judul Program Pelatihan",
        colon: ":",
        text2: "Program Title",
      },
      {
        text1: "Nama Pengajar/Instruktur/Fasilitator",
        colon: ":",
        text2: "Trainer/Instructor/Facilitator Name",
      },
      {
        text1: "Tempat dan Tanggal Penyelenggaraan",
        colon: ":",
        text2: "Venue and Date",
      },
      {
        text1: "Penyelenggara",
        colon: ":",
        text2: "Training Provider",
      },
    ];
    let y = 30;
    data.forEach((val) => {
      y = render1(val.text1, val.colon, val.text2, y);
    });
    render2("Sasaran Pelatihan", ":", "Training Objective", y);
  }

  sectionNumbering(num, text, textE, y) {
    let x = this.initialX;
    this.doc.setFont("helvetica", "normal");
    this.doc.setFontSize(10);
    this.doc.text(num, x, y);
    x += 4;
    this.doc.text(text, x, y);
    this.doc.setFont("helvetica", "italic");
    const textWidth = this.doc.getTextWidth(text);
    x += textWidth + 1;
    this.doc.text(textE, x, y);
  }
  sectionNumberingLvl2(num, text, y) {
    const x = this.initialX + 5;
    this.doc.setFont("helvetica", "normal");
    this.doc.setFontSize(8);
    this.doc.text(num, x, y);
    this.doc.text(text, x + 5, y);
  }

  paragraphLvl2(text, textE, y) {
    let startX = this.initialX + 4;
    this.doc.setFontSize(10);
    this.doc.setFont("helvetica", "normal");
    this.doc.text(text, startX, y);
    const textWidth = this.doc.getTextWidth(text);
    this.doc.setFont("helvetica", "italic");
    startX += textWidth + 1;
    this.doc.text(textE, startX, y);
  }
  table() {
    // Horizontal
    this.doc.line(11, 106.5, 196.5, 106.5);
    this.doc.line(11, 155.5, 196.5, 155.5);
    this.doc.line(11, 162, 196.5, 162);
    this.doc.line(11, 119, 196.5, 119);
    this.doc.line(124.3, 116.4, 196.5, 116.4);
    this.doc.line(124.3, 113.2, 196.5, 113.2);

    // Vertical
    this.doc.line(11, 106.5, 11, 162);
    let x = 124.3;
    this.doc.line(x, 106.5, x, 155.5);
    x += 12;
    this.doc.line(x, 106.5, x, 155.5);
    this.doc.line(x, 106.5, x, 116.4);
    x += 12;
    this.doc.line(x, 119.3, x, 155.5);
    this.doc.line(x, 106.5, x, 116.4);
    x += 12;
    this.doc.line(x, 119.3, x, 155.5);
    this.doc.line(x, 106.5, x, 116.4);
    x += 12;
    this.doc.line(x, 119.3, x, 155.5);
    this.doc.line(x, 106.5, x, 116.4);
    x += 12;
    this.doc.line(x, 106.5, x, 162);

    this.doc.line(196.5, 106.5, 196.5, 162);
  }
  tableText() {
    this.doc.setFontSize(7);
    this.doc.setFont("helvetica", "normal");
    // Table Header
    this.doc.text("Deskripsi (Description)", 67.8, 113.7, { align: "center" });
    let x = 130.3;
    this.doc.text("Bobot", x, 109, { align: "center" });
    this.doc.text("Weighing", x, 112.2, { align: "center" });
    this.doc.text("%", x, 115.4, { align: "center" });
    this.doc.text("(a)", x, 118.6, { align: "center" });
    x += 12;
    this.doc.text("Kurang", x, 109, { align: "center" });
    this.doc.text("Poor", x, 112.2, { align: "center" });
    this.doc.text("1", x, 115.4, { align: "center" });
    x += 12;
    this.doc.text("Baik", x, 109, { align: "center" });
    this.doc.text("Good", x, 112.2, { align: "center" });
    this.doc.text("2", x, 115.4, { align: "center" });
    x += 12;
    this.doc.text("Sgt. Baik", x, 109, { align: "center" });
    this.doc.text("Very Good", x, 112.2, { align: "center" });
    this.doc.text("3", x, 115.4, { align: "center" });
    x += 12;
    this.doc.text("istimewa", x, 109, { align: "center" });
    this.doc.text("Excellence", x, 112.2, { align: "center" });
    this.doc.text("4", x, 115.4, { align: "center" });
    x += 12;
    this.doc.text("Total", x, 109, { align: "center" });
    this.doc.text("(a x b)", x, 118.6, { align: "center" });
    this.doc.text("(b)", 160.3, 118.6, { align: "center" });
    this.doc.setFontSize(8);
    // Number Item
    this.doc.text("1.1. ", 12.6, 123.2);
    this.doc.text("1.2. ", 12.6, 134.8);
    this.doc.text("1.3. ", 12.6, 146.3);
    // Text item
    this.paragraph("Bagaimana peningkatan pengetahuan untuk menunjang pekerjaan setelah mengikuti pelatihan ini? How their knowledge improvement to support their job after following this training", 102.5, 17.8, 123.2);
    this.paragraph("Bagaimana peningkatan ketrampilan untuk menunjang pekerjaan setelah mengikuti pelatihan ini? How their skill improved to support their job after following this training ?", 102.5, 17.8, 134.8);
    this.paragraph("Bagaimana peningkatan  kinerja untuk menunjang pekerjaan setelah mengikuti pelatihan ini? How their Performance improved to support their job after following this training ? ", 102.5, 17.8, 146.3);
    // Total Item
    this.doc.text("Average Final Score ( Nilai akhir rata-rata )", 17.8, 158.7);
  }

  paragraph(text, maxWidth, x, y) {
    const lines = this.doc.splitTextToSize(text, maxWidth);
    this.doc.text(lines, x, y);
  }
  checkboxList() {
    this.doc.setFontSize(8);
    this.doc.setFont("helvetica", "normal");

    const startY = 174.6;
    const gapY = 6.5;

    const data = [
      {
        text: "Sangat bermanfaat untuk menunjang pekerjaan (Very High important for this job), Jika total nilai (If Total Score)",
        value: "4",
      },
      {
        text: "Bermanfaat untuk menunjang pekerjaan (High Important for this job) , Jika total nilai (If Total Score) ",
        value: "3 - 3.99",
      },
      {
        text: "Cukup bermanfaat untuk menunjang pekerjaan (Medium Important for this job) , Jika total nilai (If Total Score)",
        value: "2 - 2.99",
      },
      {
        text: "Kurang bermanfaat untuk menunjang pekerjaan (Low Important for this job), Jika total nilai ( If Total Score ) ",
        value: "0 - 1.99",
      },
    ];

    data.forEach((item, i) => {
      const y = startY + i * gapY;

      // kotak
      this.doc.line(16.8, y - 2.7, 22.8, y - 2.7); // atas
      this.doc.line(16.8, y + 0.5, 22.8, y + 0.5); // bawah
      this.doc.line(16.8, y - 2.7, 16.8, y + 0.5); // kiri
      this.doc.line(22.8, y - 2.7, 22.8, y + 0.5); // kanan

      // text
      this.doc.text(item.text, 27, y);
      this.doc.text(":", 170, y);
      this.doc.text(item.value, 173, y);
    });
  }
  drawDashedLines(startX, startY, totalLines) {
    const endX = 189.6;
    const gap = 3.2;

    // aktifkan garis putus-putus
    this.doc.setLineDashPattern([0.5, 0.5], 0);

    for (let i = 0; i < totalLines; i++) {
      const y = startY + i * gap;
      this.doc.line(startX, y, endX, y);
    }

    // reset ke garis normal
    this.doc.setLineDashPattern([], 0);
  }
  weighing() {
    this.doc.setFontSize(7);
    const doc = this.doc;
    const startX = 11.8;
    const startY = 245;
    let y = startY;
    const lineHeight = 4;
    const listScorePrint = (s, xx) => {
      s.forEach((item) => {
        let x = xx;
        this.doc.setFont("helvetica", "normal");
        x += 16;
        this.doc.text(item.no, x, y);
        x += 5;
        this.doc.text(item.text, x, y);
        const textWidth = this.doc.getTextWidth(item.text);
        x += textWidth + 3;
        this.doc.setFont("helvetica", "italic");
        this.doc.text(item.en, x, y);
        const textWidthEnd = this.doc.getTextWidth(item.en);
        x += textWidthEnd + 1;
        this.doc.setFont("helvetica", "normal");
        this.doc.text(":", x, y);

        // align kanan biar rapi
        x += 10;
        this.doc.text(item.val, x, y, { align: "right" });

        y += lineHeight;
      });
    };
    const headingNumbering = (s, xx) => {
      let x = xx;
      this.doc.setFont("helvetica", "bold");
      x += 4;
      this.doc.text(s.num, x, y);
      x += 12;
      this.doc.text(s.textEn, x, y);
      this.doc.setFont("helvetica", "italic");
      const textWidth = this.doc.getTextWidth(s.textEn);
      x += textWidth + 3;
      this.doc.text(s.textId, x, y);
    };

    this.doc.setFont("helvetica", "normal");
    this.doc.text("Note :", startX, y);

    this.doc.text("Bobot Penilaian (Scoer Weighing)", startX + 9.2, y);

    y += lineHeight;

    // =========================
    // 1. Seminar Category
    // =========================

    const headingNum1 = {
      num: "1",
      textEn: "Seminar Category",
      textId: "(Kategori Seminar)",
    };
    headingNumbering(headingNum1, startX);

    y += lineHeight;

    // data seminar
    const seminar = [
      { no: "1.1.", text: "Pertanyaan No. 1.1., bobotnya", en: "(Question No.1.1., its weighing)", val: "40%" },
      { no: "1.2.", text: "Pertanyaan No. 1.2., bobotnya", en: "(Question No.1.2., its weighing)", val: "20%" },
      { no: "1.3.", text: "Pertanyaan No. 1.3., bobotnya", en: "(Question No.1.3., its weighing)", val: "40%" },
    ];
    listScorePrint(seminar, startX);

    // =========================
    // 2. Training Category
    // =========================
    y += 2;
    const headingNum2 = {
      num: "2",
      textEn: "Training/Course Category",
      textId: "(Kategori Pelatihan/Kursus)",
    };
    headingNumbering(headingNum2, startX);
    y += lineHeight;
    const training = [
      { no: "2.1.", text: "Pertanyaan No. 1.1., bobotnya", en: "(Question No.1.1., its weighing)", val: "20%" },
      { no: "2.2.", text: "Pertanyaan No. 1.2., bobotnya", en: "(Question No.1.2., its weighing)", val: "40%" },
      { no: "2.3.", text: "Pertanyaan No. 1.3., bobotnya", en: "(Question No.1.3., its weighing)", val: "40%" },
    ];
    listScorePrint(training, startX);
  }

  footer() {
    this.doc.setFontSize(6);
    this.doc.setFont("helvetica", "italic");
    this.doc.text(`This document was automatically generated via ppdmaco.com on ${new Date().toLocaleString()}`, 11.6, 290);
  }
  header() {
    this.doc.setFontSize(6);
    this.doc.setFont("helvetica", "normal");
    this.doc.text("Form. No. SFP/09/F-006", 201, 9, { align: "right" });
  }

  sign() {
    const startX = 160;
    const startY = 235;
    const lineHeight = 4;
    this.doc.setFontSize(8);
    this.doc.setFont("helvetica", "normal");

    // ============================
    // Tulisan Atas
    // ============================
    let x = startX;
    let y = startY;
    this.doc.text("Penilai (Evaluator)", x, y, { align: "center" });
    y += lineHeight * 4;
    const lineLength = 40;
    this.doc.line(x - lineLength / 2, y, x + lineLength / 2, y);
  }
  async logoPrint() {
    const blob = await generalImage(`/sisLogo`);
    const base64 = await blobToBase64(blob);
    if (base64) {
      this.doc.addImage(base64, "JPEG", 7.7, 7, 30, 11);
    }
  }
}
